var React = require('react');

function Kundalini (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M19,35L2,9h34L19,35z M19,19.476\n\tC19.231,18.884,19.208,17,17.375,17C15.875,17,15,17.99,15,19.623c0,2,1.5,3.377,4,3.377c2,0,4-1.464,4-4.464S20.936,13,17.293,13\n\tC13.53,13,11,15.54,11,19.625C11,24,14.583,27,19,27c5.75,0,8-4.292,8-8.791C27,14.625,24.25,9,17.313,9"}));
}

Kundalini.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = Kundalini;

Kundalini.default = Kundalini;
